const Universe = () => {
  return (
    <div className="universe fixed right-24 top-1/4 hidden xl:block">
      <img src="/astronaut.png" alt="우주 비행사" className="astro" />
      <img src="/rocket.png" alt="로켓" className="rocket" />
    </div>
  );
};

export default Universe;
